export default __webpack_public_path__ + "images/af8b0f0859b26fcb569458f256d0ffab-holiday.png";